import React, { useEffect, useState } from 'react'
import Header from '../../../Components/Header'
import AccountSidebar from '../AccountSidebar'
import { BrowserView, MobileView } from 'react-device-detect';
import { ApiService } from '../../../Components/Services/apiServices';
import { showToast } from '../../../Components/Utlis/toastUtlis';

const MyProfile = () => {

    const [user, setUser] = useState(null);
    const [newName, setNewName] = useState("");



    useEffect(() => {
        const userData = localStorage.getItem("USER_DATA");
        if (userData) {
            const parsedUser = JSON.parse(userData);
            setUser(parsedUser);
            setNewName(parsedUser.username);
        }
    }, []);


    const handleUpdate = async () => {
        if (!user) {
            showToast("error", "User Not Found!")
            return;
        }

        if (!newName.trim()) {
            showToast("error", "Full Name Cannot be Empty!")
            return;
        }

        try {
            const response = await ApiService.Commanpostrequest("update-profile", {
                user_id: user.id,
                full_name: newName
            });

            // console.log("API Response:", response);

            if (response?.data?.success) {
                const updatedUser = { ...user, username: newName };
                setUser(updatedUser);
                localStorage.setItem("USER_DATA", JSON.stringify(updatedUser));
                showToast("success", "Profile updated successfully!")
            } else {
                const updatedUser = { ...user, username: newName };
                setUser(updatedUser);
                localStorage.setItem("USER_DATA", JSON.stringify(updatedUser));
                showToast("success", "Profile updated successfully!")
            }
        } catch (error) {
            console.error("Error updating profile:", error);
            alert("An error occurred. Please try again.");
        }
    };



    return (
        <>
            <Header />

            <BrowserView>
                <div className="account-container">
                    <AccountSidebar />
                    <div className="account-content container py-5">
                        <div className="col-lg-9 col-md-8">
                            <div className="card shadow-sm border-0 p-4">
                                <h3 className="mb-4 text-center text-md-start">My Profile</h3>

                                {user ? (
                                    <div className="profile-details">
                                        {/* <div className="d-flex flex-column align-items-center text-center">
                                            <div className="profile-avatar mb-3">
                                                <i className="fa fa-user-circle"></i>
                                            </div>
                                            <h5 className="fw-bold">{user.username || "N/A"}</h5>
                                            <p className="text-muted">{user.email || "N/A"}</p>
                                        </div> */}

                                        {/* Profile Information */}
                                        <div className="mt-4">
                                            <ul className="list-group">
                                                <li className="list-group-item">
                                                    <strong>Username:</strong>
                                                    <input
                                                        type="text"
                                                        className="form-control mt-2"
                                                        value={newName}
                                                        onChange={(e) => setNewName(e.target.value)}
                                                    />
                                                </li>
                                                <li className="list-group-item">
                                                    <strong>Email:</strong>
                                                    <input
                                                        type="text"
                                                        className="form-control mt-2"
                                                        value={user.email || "N/A"}
                                                        disabled
                                                    />
                                                </li>
                                                <li className="list-group-item">
                                                    <strong>Mobile:</strong>
                                                    <input
                                                        type="text"
                                                        className="form-control mt-2"
                                                        value={user.mobile || "N/A"}
                                                        disabled
                                                    />
                                                </li>
                                            </ul>
                                            <button className='btn btn-primary w-50 mt-4' onClick={handleUpdate}>Update</button>


                                        </div>
                                    </div>
                                ) : (
                                    <p className="text-center text-muted">No user data found.</p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </BrowserView>


            <MobileView>
                <div className="col-lg-9 col-md-8">
                    <div className="card shadow-sm border-0 p-4">
                        <h3 className="mb-4 text-center text-md-start mt-5">My Profile</h3>

                        {user ? (
                            <div className="profile-details">
                                {/* <div className="d-flex flex-column align-items-center text-center">
                                    <div className="profile-avatar mb-3">
                                        <i className="fa fa-user-circle"></i>
                                    </div>
                                    <h5 className="fw-bold">{user.username || "N/A"}</h5>
                                    <p className="text-muted">{user.email || "N/A"}</p>
                                </div> */}

                                {/* Profile Information */}
                                <div className="mt-4">
                                    <ul className="list-group">
                                        <li className="list-group-item">
                                            <strong>Username:</strong>
                                            <input
                                                type="text"
                                                className="form-control mt-2"
                                                value={newName}
                                                onChange={(e) => setNewName(e.target.value)}
                                            />
                                        </li>
                                        <li className="list-group-item">
                                            <strong>Email:</strong>
                                            <input
                                                type="text"
                                                className="form-control mt-2"
                                                value={user.email || "N/A"}
                                                disabled
                                            />
                                        </li>
                                        <li className="list-group-item">
                                            <strong>Mobile:</strong>
                                            <input
                                                type="text"
                                                className="form-control mt-2"
                                                value={user.mobile || "N/A"}
                                                disabled
                                            />
                                        </li>
                                    </ul>
                                    <div className='text-center'>
                                    <button className='btn btn-primary w-50 mt-4' onClick={handleUpdate}>Update</button>

                                    </div>

                                </div>

                            </div>
                        ) : (
                            <p className="text-center text-muted">No user data found.</p>
                        )}
                    </div>
                </div>
            </MobileView>


        </>
    )
}

export default MyProfile
